var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dialog',{staticClass:"dialog",on:{"closeModal":_vm.close}},[_c('Header',{on:{"close":_vm.close}}),_c('div',{staticClass:"content"},[_c('Images'),_c('Info')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }